<template>
  <ul
    v-bind="rootProps"
    ref="root"
    :class="{
      'sb-dropdown': true,
      'sb-dropdown--inline': props.inline,
    }"
    role="menu"
    tabindex="0"
    @keydown="($event) => $emit('keydown', $event)"
  >
    <p v-if="title" class="sb-dropdown__title">{{ title }}</p>
    <slot />
  </ul>
</template>

<script setup lang="ts">
import { reactiveOmit } from '@vueuse/core'
import type { HTMLAttributes } from 'vue'

export type DropdownProps = {
  /**
   * If true, the dropdown will not have the borders
   */
  inline?: boolean

  /**
   * The dropdown ID
   */
  id?: string

  /**
   * Defines a title for the dropdown
   */
  title?: string
} & /* @vue-ignore */ HTMLAttributes
const props = withDefaults(defineProps<DropdownProps>(), {
  inline: false,
  id: undefined,
  title: undefined,
})
const rootProps = reactiveOmit(props, ['inline', 'title'])
defineEmits(['close', 'keydown'])
</script>

<style lang="scss" src="./dropdown.scss"></style>
